import { generateClient } from "aws-amplify/api";

import { buildAuditContextHeaderValue } from "./auditContextStore";

/**
 * Shared Amplify v6 GraphQL client that attaches the X-Audit-Context header to
 * every operation. Amplify v6 generateClient() ignores the legacy
 * API.graphql_headers config, so the audit header is supplied via the
 * client-level `headers` option (CommonPublicClientOptions.headers, typed as
 * CustomHeaders).
 *
 * `headers` MUST be a function so Amplify evaluates it per request rather than
 * once at client creation: in @aws-amplify/api-graphql the client-level headers
 * function is awaited inside `_graphql` on every `client.graphql(...)` call
 * (see internals/v6.mjs `headers = additionalHeaders || internals.headers` and
 * InternalGraphQLAPI `if (typeof additionalHeaders === 'function') ... await
 * additionalHeaders(requestOptions)`). This means the returned value always
 * reflects the live audit context store (user/team resolved after login + team
 * selection).
 *
 * Authorization is intentionally NOT set here: Amplify's Cognito USER_POOL auth
 * mode injects the access token separately (and merges it before these custom
 * headers), so overriding it could break auth. Only X-Audit-Context is added.
 */
export const generateAuditedClient = () =>
  generateClient({
    headers: async () => ({
      "X-Audit-Context": buildAuditContextHeaderValue(),
    }),
  });
